// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import Access_deniedSvg from "./access_denied.svg";
let imageUri = Access_deniedSvg;
let styles = {
  root: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x1rzw5jd",
    "height-kZKoxP": "height-x5yr21d",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-xrsdzbr",
    "width-kzqmXN": "width-x14atkfc",
    $$css: "wino-gc:src/app/Error/AccessDeniedPage.res.js:13"
  },
  image: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "width-kzqmXN": "width-x1iy3nof",
    $$css: "wino-gc:src/app/Error/AccessDeniedPage.res.js:23"
  },
  textContainer: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x17d4w8g",
    $$css: "wino-gc:src/app/Error/AccessDeniedPage.res.js:27"
  }
};
function styleProps() {
  return {
    className: "alignSelf-xamitd3 display-x78zum5 flexDirection-xdt5ytf gap-x1rzw5jd height-x5yr21d justifyContent-xl56j7k marginTop-xrsdzbr width-x14atkfc",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:13"
  };
}
function imageStyleProps() {
  return {
    className: "alignSelf-xamitd3 width-x1iy3nof",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:23"
  };
}
function textContainerStyleProps() {
  return {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x17d4w8g",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:27"
  };
}
function AccessDeniedPage(props) {
  let match = {
    className: "alignSelf-xamitd3 display-x78zum5 flexDirection-xdt5ytf gap-x1rzw5jd height-x5yr21d justifyContent-xl56j7k marginTop-xrsdzbr width-x14atkfc",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:13"
  };
  let match$1 = {
    className: "alignSelf-xamitd3 width-x1iy3nof",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:23"
  };
  let match$2 = {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x17d4w8g",
    "data-style-src": "wino-gc:src/app/Error/AccessDeniedPage.res.js:27"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx("img", {
      className: match$1.className,
      style: match$1.style,
      src: imageUri
    }), JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsx(Title.make, {
        children: I18n.t("access_denied_page.title.text"),
        align: "center"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("access_denied_page.subtitle.text"),
        align: "center",
        size: "large"
      })],
      className: match$2.className,
      style: match$2.style
    })],
    className: match.className,
    style: match.style
  });
}
let make = AccessDeniedPage;
export { imageUri, styles, styleProps, imageStyleProps, textContainerStyleProps, make };
/* imageUri Not a pure module */